module.exports = __webpack_public_path__ + "static/media/j_of_spades2.08fb2e83.png";